import React from 'react';
import './FeatureCard.css';

const FeatureCard = ({ icon, title, description, progress }) => {
  return (
    <div className="feature-card-main">
      <div className="card-header-flex">
        <div className="card-icon-wrapper">
          <i className={`bi ${icon}`}></i>
        </div>
        <h3 className="card-title-text">{title}</h3>
      </div>
      <div className="card-divider-line">
        <div className="divider-progress-fill" style={{ width: progress }}></div>
      </div>
      <p className="card-body-desc">{description}</p>
    </div>
  );
};

export default FeatureCard;